/**
 * Check for proper email regex
 * @param {String} email
 * @return {Boolean} - Email validity
 */
/* eslint-disable max-len, lines-around-comment */
const validateEmail = (email) => {
  const regex = /.+@.+/;
  return regex.test(email);
};

export default validateEmail;